export * from './json-pointer/json-pointer'

// For TypeScript compatibility we import and export it this way
import * as _default from './json-pointer/export'
export { _default as default }
